<template>
  <van-picker class="vg-picker"
              v-bind="$attrs"
              v-on="$listeners">
    <template #title>
      <slot name="title"></slot>
    </template>
  </van-picker>
</template>

<script>
import {Picker} from "vant";

export default {
  name: "VgPicker",
  components: {
    'van-picker': Picker,
  },
}
</script>

<style scoped>
.vg-picker >>> .van-picker__toolbar {
  height: 40px;
}

.vg-picker >>> .van-picker__toolbar::after {
  content: "";
  position: absolute;
  top: 40px;
  left: 12px;
  display: block;
  height: 1px;
  width: calc(100% - 24px);
  border-top: 1px solid #F0F0F0;
}

.vg-picker >>> .van-picker__title {
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
}

.vg-picker >>> .van-picker__cancel {
  box-sizing: unset;
  padding: 12px 12px 7px;
  height:  20px;;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}

.vg-picker >>> .van-picker__confirm {
  box-sizing: unset;
  padding: 12px 12px 7px;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #2897FF;
  line-height: 20px;
}
</style>